import React from 'react';
import '../styles/completeProjects.css'; // Adjust the path if needed

const stats = [
  { value: '10K', label: 'Project Completed' },
  { value: '150+', label: 'Coverage Areas' },
  { value: '5K', label: 'Satisfied Customer' },
  { value: '100', label: 'Certified Technician' },
];

const completeProjects = () => (
  <div className="stats-section">
    <div className="stats-row">
      {stats.map((stat, idx) => (
        <div className="stat-box" key={idx}>
          <div className="stat-value">{stat.value}</div>
          <div className="stat-label">{stat.label}</div>
        </div>
      ))}
    </div>
  </div>
);

export default completeProjects;
